import "./FreshFrozenStandard.module.css";
import Header from "@/reusable_sections/Header";
import CoreTechValues from "./sections/CoreTechValues";
import OurInspectionGuarantee from "./sections/OurInspectionGuarantee";
import MainFooter from "@/reusable_sections/Footer";
export default function FreshFrozenStandardPage() {
  return <div>
      <Header />
      <CoreTechValues />
      <OurInspectionGuarantee />
      <MainFooter />
    </div>;
}